/* Bridges Horizon's standard cart events to the Fieldwrks product page.
   Kept in its own module so that a browser without import-map support, or a
   blocked Shopify CDN, degrades add-to-cart to a normal form post instead of
   breaking the whole product page. */
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

window.FWCartEvents = { CartLinesUpdateEvent: CartLinesUpdateEvent, CartErrorEvent: CartErrorEvent };
document.dispatchEvent(new CustomEvent('fw:cart-events-ready'));
